import React from 'react'
import PropTypes from 'prop-types'
import styles from './table-wrap.styl'

const Wrap = ({ children }) => {
  return (
    <table className={styles.table}>
      {children}
    </table>
  )
}

Wrap.propTypes = { children: PropTypes.any }
Wrap.displayName = 'Table'

export default Wrap
